(function Chat($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Chats/linkToClient', function onload() {
			Adzuki.Typeahead('.chat-client-search', '/Clients/search', function select(item) {
				$('#client_id').val(item.id);
			});
		});
	});
}(jQuery, window.Adzuki || {}));
